import { motion } from "framer-motion";

const HeroSection = () => {
  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
    >
      {/* Background image - from original Canva homepage */}
      <div className="absolute inset-0">
        <img
          src="https://customer-assets.emergentagent.com/job_inner-light-path-2/artifacts/67vql2vp_aaa.jpg"
          alt="Light Workers House - Percorsi di crescita e luce interiore"
          className="w-full h-full object-cover"
        />
        <div className="hero-overlay absolute inset-0" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
        <div className="bg-white/60 backdrop-blur-md rounded-[2rem] py-12 px-8 md:px-16 shadow-[0_8px_32px_rgba(68,47,35,0.06)]">
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.3 }}
            className="font-heading text-5xl sm:text-6xl lg:text-7xl font-bold tracking-tight leading-none mb-5"
            style={{ color: "#B8941E" }}
          >
            Light Workers House
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.5 }}
            className="font-heading text-2xl md:text-3xl font-semibold mb-8"
            style={{ color: "#442F23" }}
          >
            La casa dei Guerrieri di Luce
          </motion.p>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.7 }}
            className="font-body text-base md:text-lg max-w-2xl mx-auto mb-10 leading-relaxed"
            style={{ color: "rgba(68,47,35,0.85)" }}
          >
            Un cammino interiore di risveglio, uno spazio di gruppo protetto
            in cui vivrai esattamente il processo che ti serve per incarnare
            il tuo guerriero di Luce, risvegliare il tuo potere personale
            e realizzare lo scopo della tua vita.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.9 }}
            className="flex flex-col sm:flex-row gap-4 justify-center"
          >
            <button
              onClick={() => scrollTo("pricing-section")}
              className="btn-primary text-base"
              data-testid="hero-cta-primary"
            >
              Inizia il tuo percorso di luce
            </button>
            <button
              onClick={() => scrollTo("intro-section")}
              className="font-body font-medium text-[#AC8E60] border-2 border-[#AC8E60]/40 rounded-full px-8 py-3.5 hover:border-[#AC8E60] hover:bg-[#AC8E60]/10 transition-all duration-300"
              data-testid="hero-cta-secondary"
            >
              Scopri di pi&ugrave;
            </button>
          </motion.div>
        </div>
      </div>

      {/* Scroll indicator */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.5, duration: 1 }}
        className="absolute bottom-8 left-1/2 -translate-x-1/2"
      >
        <motion.div
          animate={{ y: [0, 8, 0] }}
          transition={{ repeat: Infinity, duration: 2, ease: "easeInOut" }}
          className="w-6 h-10 border-2 border-[#AC8E60]/40 rounded-full flex justify-center pt-2"
        >
          <div className="w-1 h-2 bg-[#AC8E60]/60 rounded-full" />
        </motion.div>
      </motion.div>
    </section>
  );
};

export default HeroSection;
